<template>
  <div :class="getBannerContainerClass()">
    <FlexContainer justifyContent="center">
      <div :class="getBannerClass()">
        <FlexContainer justifyContent="center" alignItems="center">
          {{ message }}
        </FlexContainer>
      </div>
    </FlexContainer>
  </div>
</template>

<script>
import FlexContainer from "./FlexContainer.vue";

export default {
  props: {
    type: String,
    message: String,
    shown: Boolean,
  },
  methods: {
    getBannerContainerClass() {
      let classes = "notificationBannerContainer";
      classes += !this.shown ? " hidden" : "";
      return classes;
    },
    getBannerClass() {
      return `notificationBanner ${this.type}`;
    },
  },
  components: { FlexContainer },
};
</script>

<style scoped>
.notificationBannerContainer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  transition: 0.3s ease;

  .notificationBanner {
    width: 90%;
    padding: 1rem;
    border-radius: 1rem 1rem 0 0;
    font-weight: bold;
    color: white;

    &.success {
      background-color: var(--vt-c-green);
    }

    &.error {
      background-color: var(--vt-c-red);
    }
  }

  &.hidden {
    bottom: -4rem;
  }
}
</style>
